// extracted by mini-css-extract-plugin
export default {"background":"zzBPY","constructionModal":"dS9gl","constructionModal__withAdaptive":"T_ml7","modal":"qpkCy","title":"M0AOL","content":"bGizz","buttonClose":"Sm2at","icon":"SeAYf"};